import { render, staticRenderFns } from "./CategoryAccounts.vue?vue&type=template&id=04db6448"
import script from "./CategoryAccounts.vue?vue&type=script&lang=js"
export * from "./CategoryAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports